import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AwbComponent } from './awb.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [AwbComponent],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [AwbComponent]
})
export class AwbModule { }
